import React from "react"
import styled from "styled-components"
import { rem } from "polished"

import { media } from "@sr/common"
import {
  BdTitle5,
  BlockContentBlock,
  SanityImg,
  SemiBdTitle3,
} from "@sr/gatsby-theme-ui"
import SanityImage from "gatsby-plugin-sanity-image"

export type HardwareCategoryOperationalBenefitsContentSection = {
  benefitTitle: string
  sectionImg: SanityImg
  _rawText: any
}

export interface HardwareCategoryOperationalBenefitsPropsShape {
  operationalBenefits: {
    title: string
    contentSections: HardwareCategoryOperationalBenefitsContentSection[]
  }
}

const HardwareCategoryOperationalBenefits = ({
  operationalBenefits,
}: HardwareCategoryOperationalBenefitsPropsShape) => {
  return (
    <HardwareCategoryOperationalBenefitsStyled>
      <div className="hardware-category-operational-benefits__container">
        <SemiBdTitle3>{operationalBenefits?.title}</SemiBdTitle3>
        <div className="hardware-category-operational-benefits__options-container">
          {operationalBenefits?.contentSections?.map((section, i) => {
            return (
              <div
                className="hardware-category-operational-benefits__option-container"
                key={i}
              >
                {section?.sectionImg?.asset && (
                  <SanityImage
                    alt={section?.sectionImg?.alt || ""}
                    asset={section?.sectionImg?.asset}
                    className="article-author__img"
                    crop={section?.sectionImg?.crop}
                    hotspot={section?.sectionImg?.hotspot}
                  />
                )}
                <BdTitle5>{section?.benefitTitle}</BdTitle5>
                <BlockContentBlock blocks={section?._rawText} />
              </div>
            )
          })}
        </div>
      </div>
    </HardwareCategoryOperationalBenefitsStyled>
  )
}

export default HardwareCategoryOperationalBenefits

const HardwareCategoryOperationalBenefitsStyled = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${rem(40)} ${rem(16)} ${rem(40)};

  @media ${media.midUp} {
    padding: 0 0 ${rem(72)};
  }

  @media ${media.stMidUp} {
    padding: ${rem(40)} 0 ${rem(120)};
  }

  .hardware-category-operational-benefits__container {
    @media ${media.midUp} {
      max-width: ${rem(616)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(1073)};
    }
  }

  h3 {
    font-size: ${rem(32)};
    line-height: ${rem(40)};

    @media ${media.midUp} {
      font-size: ${rem(40)};
      line-height: ${rem(48)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(831)};
    }
  }

  .hardware-category-operational-benefits__options-container {
    display: flex;
    flex-direction: column;
    gap: ${rem(16)};
    padding-top: ${rem(24)};

    @media ${media.midUp} {
      padding-top: ${rem(32)};
      flex-direction: column;
      /* max-width: ${rem(616)}; */
      gap: 0;
    }

    @media ${media.stMidUp} {
      flex-direction: row;
      gap: ${rem(88)};
    }

    .hardware-category-operational-benefits__option-container {
      display: flex;
      flex-direction: column;
      gap: ${rem(8)};

      @media ${media.midUp} {
        width: 100%;
      }

      img {
        width: ${rem(56)};
        height: ${rem(56)};
      }

      h5 {
        font-size: ${rem(20)};
        line-height: ${rem(32)};

        @media ${media.midUp} {
          font-size: ${rem(24)};
          line-height: ${rem(32)};
          /* max-width: ${rem(158)}; */
        }
      }

      a {
        text-decoration: underline;
        text-underline-offset: ${rem(6)};
        max-width: ${rem(128)};
        margin-top: ${rem(8)};

        @media ${media.midUp} {
          font-size: ${rem(20)};
          line-height: ${rem(24)};
        }

        @media ${media.stMidUp} {
        }
      }
    }
  }
`
